export const COUNTRIES = [
    'Australia',
    'Belgium',
    'Brazil',
    'Bulgaria',
    'Cyprus',
    'Czech Republic',
    'Guatemala',
    'Mexico',
    'Honduras',
    'Costa Rica',
    'Colombia',
    'Greece',
    'Hungary',
    'India',
    'Indonesia',
    'Ireland',
    'Italy',
    'Syria',
    'Japan',
    'Latvia',
    'Lithuania',
    'Luxembourg',
    'Malta',
    'Jamaica',
    'Ireland',
    'Turkey',
    'United Kingdom',
    'United States'
]